import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-int.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-10857cb8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-detail"
};
var _hoisted_2 = {
  class: "box realTimeParams"
};
var _hoisted_3 = {
  class: "label"
};
var _hoisted_4 = {
  class: "value"
};
var _hoisted_5 = {
  class: "label"
};
var _hoisted_6 = {
  class: "red"
};
var _hoisted_7 = {
  class: "box"
};
var _hoisted_8 = {
  key: 0,
  class: "box openTimeRange"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "titleInfo"
  }, "近三日数据", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "openBlock"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "mr-4"
  }, "开机"), /*#__PURE__*/_createElementVNode("div", {
    class: "closeBlock"
  }), /*#__PURE__*/_createElementVNode("span", null, "关机")], -1);
});
var _hoisted_11 = {
  class: "chart flex align-center"
};
var _hoisted_12 = {
  class: "flex align-center justify-between"
};
var _hoisted_13 = {
  class: "text"
};
var _hoisted_14 = {
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_title = _resolveComponent("c-title");
  var _component_c_date_select = _resolveComponent("c-date-select");
  var _component_current_select = _resolveComponent("current-select");
  var _component_line_echart = _resolveComponent("line-echart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "实时参数"
  }), !_ctx.tmpShow ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.newClassReal, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "realTimeParamsItem",
      key: item.name
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(item.value), 1)]);
  }), 128)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceTemperList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "realTimeParamsItem",
      key: item.text
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.text), 1), _createElementVNode("div", {
      class: _normalizeClass(["value", {
        red: item.value === item.variableThreshold,
        yellow: parseInt(item.value) / parseInt(item.variableThreshold) >= 0.9
      }])
    }, [_createTextVNode(_toDisplayString(item.value) + " ", 1), _createElementVNode("span", _hoisted_6, "(报警：" + _toDisplayString(item.variableThreshold) + ")", 1)], 2)]);
  }), 128))]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_c_title, {
    title: "历史曲线"
  }), _createVNode(_component_c_date_select, {
    backgroundColor: "#F6F7F8",
    class: "mb-3",
    onConfirmDate: _ctx.confirmDate
  }, null, 8, ["onConfirmDate"]), _createVNode(_component_current_select, {
    columns: _ctx.deviceTemperList,
    onConfirmCurrent: _ctx.confirmCurrent
  }, null, 8, ["columns", "onConfirmCurrent"]), _createVNode(_component_line_echart, _normalizeProps(_guardReactiveProps(_ctx.saleTrend)), null, 16)]), !_ctx.tmpShow ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_c_title, {
    title: "开机时间段"
  }, {
    info: _withCtx(function () {
      return [_hoisted_9];
    }),
    _: 1
  }), _hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openCloseList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "openCloseChart",
      key: index
    }, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.runTimeList, function (iten, indey) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["point", {
          blue: iten.status === '1',
          grey: iten.status === '0'
        }]),
        style: _normalizeStyle({
          width: "".concat(Number(iten.value), "%")
        }),
        key: indey
      }, null, 6);
    }), 128))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(item.startTime), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(item.endTime), 1)])]);
  }), 128))])) : _createCommentVNode("", true)]);
}